let commonConfig = {
  maxBoards: 10
}

export default commonConfig;